import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { clearToken } from '../api'

interface NavProps {
  logoUrl?: string | null
  firstName?: string | null
  email?: string | null
  onSignOut: () => void
}

function initials(firstName: string | null | undefined, email: string | null | undefined): string {
  if (firstName) return firstName.slice(0, 2).toUpperCase()
  if (email) return email.slice(0, 2).toUpperCase()
  return '?'
}

export default function Nav({ logoUrl, firstName, email, onSignOut }: NavProps) {
  const [menuOpen, setMenuOpen] = useState(false)
  const navigate = useNavigate()

  function handleSignOut() {
    clearToken()
    onSignOut()
    setMenuOpen(false)
  }

  return (
    <nav className="p-nav">
      <div className="p-nav-logo">
        {logoUrl ? (
          <img src={logoUrl} alt="The Successful Bookkeeper" />
        ) : (
          <span style={{ fontFamily: 'var(--heading)', fontSize: 15, fontWeight: 600 }}>TSB</span>
        )}
        <span className="p-nav-label">My Roadmap</span>
      </div>

      {(firstName || email) && (
        <div className="p-nav-meta">
          <span style={{ fontSize: 13 }}>{firstName ?? email}</span>
          <div
            className="p-avatar"
            onClick={() => setMenuOpen(o => !o)}
            role="button"
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && setMenuOpen(o => !o)}
          >
            {initials(firstName, email)}
            {menuOpen && (
              <div className="p-avatar-menu">
                <button onClick={() => { setMenuOpen(false); navigate('/notifications') }}>Notifications</button>
                <button onClick={handleSignOut} className="danger">Sign out</button>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  )
}
